<template>
	<div>
		<v-row>
			<v-col cols="12" md="6">
				<generic-autocomplete
					:api="api.regions.basePart"
					:queryProps="api.regions.props"
					:queryPropValues="[this.selectedMandatorId]"
					:label="txt.labels.regions"
					:triggerValue="openCloseCounterLocal"
					:preSelectAndHideIfOneItem="false"
					:selectAllOption="false"
					:groupingEffect="false"
					:disabled="disabled"
					@modelEmit="(...args) => this.emitSelectedValue('regions',...args)"
					@loading="(...args) => this.emitLoadingVariables('regions',...args)"
					@errorEmit="(...args) => this.emitErrorEvent('regions',...args)"
				/>
			</v-col>
			<v-col cols="12" md="6">
				<generic-autocomplete
					:api="api.productSkuFirstParts.basePart"
					:queryProps="api.productSkuFirstParts.props"
					:queryPropValues="[this.selectedMandatorId]"
					:label="txt.labels.productSkuFirstParts"
					:triggerValue="openCloseCounterLocal"
					:preSelectAndHideIfOneItem="false"
					:selectAllOption="false"
					:groupingEffect="false"
					:disabled="disabled"
					@modelEmit="(...args) => this.emitSelectedValue('productSkuFirstParts',...args)"
					@loading="(...args) => this.emitLoadingVariables('productSkuFirstParts',...args)"
					@errorEmit="(...args) => this.emitErrorEvent('productSkuFirstParts',...args)"
				/>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="12" md="6">
				<generic-autocomplete
					:api="api.paymentProviders.basePart"
					:queryProps="api.paymentProviders.props"
					:queryPropValues="[this.selectedMandatorId]"
					:label="txt.labels.paymentProviders"
					:triggerValue="openCloseCounterLocal"
					:preSelectAndHideIfOneItem="false"
					:selectAllOption="false"
					:groupingEffect="false"
					:disabled="disabled"
					@modelEmit="(...args) => this.emitSelectedValue('paymentProviders',...args)"
					@loading="(...args) => this.emitLoadingVariables('paymentProviders',...args)"
					@errorEmit="(...args) => this.emitErrorEvent('paymentProviders',...args)"
				/>
			</v-col>
			<v-col cols="12" md="6">
				<generic-autocomplete
					:api="api.paymentMethods.basePart"
					:queryProps="api.paymentMethods.props"
					:queryPropValues="[this.selectedMandatorId]"
					:label="txt.labels.paymentMethods"
					:triggerValue="openCloseCounterLocal"
					:preSelectAndHideIfOneItem="false"
					:selectAllOption="true"
					:groupingEffect="true"
					:disabled="disabled"
					@modelEmit="(...args) => this.emitSelectedValue('paymentMethods',...args)"
					@loading="(...args) => this.emitLoadingVariables('paymentMethods',...args)"
					@errorEmit="(...args) => this.emitErrorEvent('paymentMethods',...args)"
				/>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import GenericAutocomplete from '../../arcCustom/filters/GenericAutocomplete.vue'

export default {
	components: {
		GenericAutocomplete,
	},
	props: {
		appNameShort: {
			type: String,
			required: true,
		},
		selectedMandatorId: {
			type: Number,
			required: true,
		},
		openCloseCounter: {
			type: Number,
			default: 9999,
		},
		disabled: {
			type: Boolean,
			required: true,
		},
	},
	watch: {
		selectedMandatorId: {
			handler() {
				this.renderForce()
			},
		},
	},
	data() {
		return {
			openCloseCounterLocal: this.openCloseCounter,
			selectedTaxexemption: {},
			filteredExemptionOptions: [],
			selectedMandatorIdLocal: this.selectedMandatorId,
			selectedNationalitiesHesta: [],
			txt: {
				labels: {
					regions: 'Regions',
					productSkuFirstParts: 'Product group',
					paymentProviders: 'Payment providers',
					paymentMethods: 'Payment methods',
				},
			},
			api: {
				regions: {
					basePart: '/billing-engine/regions',
					props: [{ name: 'installationid', value: 9999 }],
				},
				productSkuFirstParts: {
					basePart: '/billing-engine/sku-first-part',
					props: [{ name: 'installationid', value: 9999 }],
				},
				paymentProviders: {
					basePart: '/billing-engine/payment-providers',
					props: [{ name: 'installationid', value: 9999 }],
				},
				paymentMethods: {
					basePart: '/billing-engine/payment-methods',
					props: [{ name: 'installationid', value: 9999 }],
				},
			},
		}
	},
	computed: {
	},
	methods: {
		renderForce() {
			this.openCloseCounterLocal += 1
		},
		emitSelectedValue(filterId, values) {
			const emittedObject = {
				filterId,
				values,
			}
			this.$emit('emitSelectedValue', emittedObject)
		},
		emitLoadingVariables(filterId, value) {
			const emittedObject = {
				filterId,
				value,
			}
			this.$emit('emitLoadingVariables', emittedObject)
		},
		emitErrorEvent(filterId, value) {
			const emittedObject = {
				filterId,
				value,
			}
			this.$emit('emitErrorEvent', emittedObject)
		},
	},
	mounted() {
		this.$nextTick(() => {
			this.renderForce()
		})
	},
}
</script>

<style scoped>
.secondaryRegistrationReportFilters {
	background-color: #d5d5d5;
}

</style>
